<div class="painel-mia">

  <header class="painel-mia__topo">
    <div>
      <h1 class="painel-mia__titulo">Resultados da Mia</h1>
      <p class="painel-mia__subtitulo">
        Cada conversa que a Mia atendeu, e no que ela deu.
      </p>
    </div>

    <div class="painel-mia__acoes">
      <button *ngIf="ehAdmin"
              type="button"
              class="painel-mia__exportar"
              (click)="exporteConversas()">
        Exportar conversas
      </button>

      <div class="painel-mia__periodos">
        <button *ngFor="let periodo of periodos"
                type="button"
                class="painel-mia__periodo"
                [class.painel-mia__periodo--ativo]="!personalizado && periodo.dias === diasSelecionados"
                (click)="selecionePeriodo(periodo.dias)">
          {{ periodo.rotulo }}
        </button>
        <button type="button"
                class="painel-mia__periodo"
                [class.painel-mia__periodo--ativo]="personalizado"
                (click)="ativePeriodoPersonalizado()">
          Período
        </button>
      </div>
    </div>
  </header>

  <div class="painel-mia__datas" *ngIf="personalizado">
    <label class="painel-mia__data">
      De
      <input type="date" [(ngModel)]="dataDe" [max]="dataAte || null">
    </label>
    <label class="painel-mia__data">
      Até
      <input type="date" [(ngModel)]="dataAte" [min]="dataDe || null">
    </label>
    <button type="button"
            class="painel-mia__aplicar"
            [disabled]="!periodoValido"
            (click)="apliquePeriodo()">
      Aplicar
    </button>
  </div>

  <div class="painel-mia__carregando" *ngIf="carregando">
    Carregando os números...
  </div>

  <div class="painel-mia__aviso painel-mia__aviso--erro" *ngIf="!carregando && erro">
    {{ erro }}
    <button type="button" class="painel-mia__link" (click)="carregue()">Tentar de novo</button>
  </div>

  <div class="painel-mia__vazio" *ngIf="!carregando && !erro && !temDados">
    <strong>Nenhum atendimento neste período.</strong>
    <span>Os números aparecem aqui assim que as primeiras conversas começarem.</span>
  </div>

  <ng-container *ngIf="!carregando && !erro && temDados">

    <!-- Alarme técnico: fica fora do denominador, então sem destaque próprio
         um bug que derruba a Mia apareceria como conversão estável. -->
    <div class="painel-mia__alarme" *ngIf="falhasTecnicas > 0">
      <span class="painel-mia__alarme-icone">!</span>
      <div>
        <strong>{{ falhasTecnicas }} {{ falhasTecnicas === 1 ? 'conversa ficou' : 'conversas ficaram' }} sem resposta da Mia.</strong>
        <span>Falha técnica: o cliente escreveu e não recebeu retorno. Isso não entra na conta de conversão.</span>
      </div>
    </div>

    <section class="painel-mia__destaques">

      <article class="cartao cartao--principal">
        <span class="cartao__rotulo">Conversão</span>
        <strong class="cartao__numero">{{ conversao }}%</strong>
        <p class="cartao__frase">
          De <strong>{{ elegiveis }}</strong> {{ elegiveis === 1 ? 'pessoa que queria comprar' : 'pessoas que queriam comprar' }},
          <strong>{{ vendas }}</strong> {{ vendas === 1 ? 'fechou' : 'fecharam' }} pedido.
        </p>
        <div class="cartao__barra">
          <span class="cartao__barra-preenchida" [style.width.%]="conversao"></span>
        </div>
      </article>

      <article class="cartao">
        <span class="cartao__rotulo">Vendido pela Mia</span>
        <strong class="cartao__numero cartao__numero--medio">{{ faturamento | currency:'BRL':'symbol':'1.2-2' }}</strong>
        <p class="cartao__frase">
          Ticket médio de <strong>{{ ticketMedio | currency:'BRL':'symbol':'1.2-2' }}</strong>.
        </p>

        <!-- Exigência de honestidade: cancelado nunca fica invisível ao lado do
             faturamento, senão a conversão parece melhor do que foi. -->
        <p class="cartao__nota" [class.cartao__nota--atencao]="pedidosCancelados > 0">
          <ng-container *ngIf="pedidosCancelados > 0; else semCancelamento">
            {{ pedidosCancelados }} {{ pedidosCancelados === 1 ? 'pedido foi cancelado' : 'pedidos foram cancelados' }}
            depois ({{ valorCancelado | currency:'BRL':'symbol':'1.2-2' }}) — já fora do valor acima.
          </ng-container>
          <ng-template #semCancelamento>Nenhum pedido cancelado no período.</ng-template>
        </p>
      </article>

      <article class="cartao">
        <span class="cartao__rotulo">Atendimentos</span>
        <strong class="cartao__numero cartao__numero--medio">{{ atendimentos }}</strong>
        <p class="cartao__frase">
          <strong>{{ elegiveis }}</strong> {{ elegiveis === 1 ? 'queria' : 'queriam' }} comprar.
          O resto foi dúvida, pós-venda, contato sem resposta ou conversa ainda em andamento.
        </p>
        <p class="cartao__nota" *ngIf="emAndamento > 0">
          {{ emAndamento }} {{ emAndamento === 1 ? 'conversa acontecendo' : 'conversas acontecendo' }} agora.
        </p>
      </article>

    </section>

    <section class="painel-mia__perdas" *ngIf="motivos.length">
      <header class="painel-mia__secao-topo">
        <h2 class="painel-mia__secao-titulo">Onde a venda se perdeu</h2>
        <span class="painel-mia__secao-nota">{{ perdas }} {{ perdas === 1 ? 'venda perdida' : 'vendas perdidas' }} no período</span>
      </header>

      <ul class="motivos">
        <li class="motivos__item"
            *ngFor="let motivo of motivos"
            [class.motivos__item--destaque]="motivo.destaque">
          <div class="motivos__cabecalho">
            <span class="motivos__titulo">{{ motivo.titulo }}</span>
            <span class="motivos__quantidade">{{ motivo.quantidade }}</span>
          </div>
          <div class="motivos__barra">
            <span class="motivos__barra-preenchida" [style.width.%]="motivo.percentual"></span>
          </div>
          <p class="motivos__dica">{{ motivo.dica }}</p>
        </li>
      </ul>
    </section>

    <section class="painel-mia__rodape">

      <article class="nota">
        <span class="nota__rotulo">Não deu para classificar</span>
        <strong class="nota__numero">{{ inconclusivos }}</strong>
        <p class="nota__texto">
          {{ percentualInconclusivo }}% dos atendimentos — na maioria, quem mandou uma mensagem e não voltou.
          Ficam de fora da conta de conversão em vez de virar chute.
        </p>
      </article>

      <article class="nota">
        <span class="nota__rotulo">Passaram por atendente</span>
        <strong class="nota__numero">{{ escalados }}</strong>
        <p class="nota__texto" *ngIf="conversaoEscalados !== null; else semEscalacao">
          {{ conversaoEscalados }}% desses fecharam pedido, contra {{ conversao }}% no geral.
        </p>
        <ng-template #semEscalacao>
          <p class="nota__texto">Nenhuma conversa precisou de atendente humano no período.</p>
        </ng-template>
      </article>

      <article class="nota">
        <span class="nota__rotulo">Custo de IA</span>
        <strong class="nota__numero">{{ custoFormatado }}</strong>
        <p class="nota__texto">
          Tudo que a Mia gastou de IA no período<ng-container *ngIf="custoPorAtendimento"> —
          média de {{ custoPorAtendimento }} por atendimento</ng-container>.
          Convertido de dólar por cotação fixa.
        </p>
      </article>

    </section>

  </ng-container>

</div>
